import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { Link } from "react-router-dom";
import { Modal } from "@material-ui/core";
export const QuizWalkthrough = (porps) => {
	const user = JSON.parse(localStorage.getItem("userData"));
	const urlElements = window.location.href.split('#')
	const hashvalue = urlElements[1];
	
	const usid = user ? user.uid : 0;
	useEffect(() => {
		serviceProvider.post("/home?type=setfirstquizseen", JSON.stringify({ uid: usid }),true).then((response) => {
			// console.log(response);
		});
	}, []);
	return (
		<>
			<div className="course-wt-bg" style={{ background: `url(${require("../../assets/img/common-img/quiz-walkthrough-bg.svg").default})` }}>
				<Modal open={true} className="single-walkthrough-modal">
					<div className="single-wlakthrough-content">
						<Link to="/" className="clsoe-btn">
							<img src={require("../../assets/img/common-img/close-icon-gray.svg").default} alt="X" />
						</Link>
						<div className="card">
							<div className="div-img">
								<img src={require("../../assets/img/common-img/quiz-wlk-img.svg").default} alt="true" />
							</div>
							{/* div-img end */}
							<div className="div-txt">
								<div className="card-content">
									<h2 className="heading-h1">Welcome to the Quiz</h2>
									<p className="para-p">
										Successfully complete the quiz by answering the questionnaire to get your certificate. In case you don’t pass,
										you can come back to retake the quiz.
									</p>
								</div>
								<div className="card-footer">
									<Link to={`/training-quiz/${hashvalue}`} className="btn-got-it">
										Got it
									</Link>
								</div>
							</div>
							{/* div-img end */}
						</div>
					</div>
				</Modal>
			</div>
		</>
	);
};
